import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "right_cont t6_detail_cont" }
const _hoisted_2 = { class: "t6_title_h1" }
const _hoisted_3 = ["srcdoc"]

import { toRefs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    content:Object
},
  setup(__props) {

const props = __props
const { content } = toRefs(props) as any


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(content).typeName), 1),
    _createElementVNode("iframe", {
      width: "100%",
      name: "newContentIframe",
      onload: "this.height=newContentIframe.document.body.scrollHeight * 1.05",
      frameborder: "0",
      scrolling: "no",
      sandbox: "allow-scripts allow-same-origin allow-popups allow-downloads",
      "data-alloy-tabstop": "true",
      tabindex: "-1",
      srcdoc: _unref(content).releaseContent
    }, null, 8, _hoisted_3)
  ]))
}
}

})